module.exports = __webpack_public_path__ + "static/media/Character-03.0a3a2528.png";